import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useSidebar } from "../SidebarContext";
import { getDecryptedUserFromCookie } from "./utils/getCookie";
import {
    ArrowLeftIcon,
    PenIcon,
    Trash2Icon,
    FileTextIcon,
    InfoIcon,
    ImageIcon,
    TagsIcon,
    BadgePercentIcon,
    PackageIcon,
    SlidersHorizontalIcon,
    StarIcon,
    FileText,
    EyeIcon,
} from "lucide-react";
import EquipmentsModal from "./EquipmentsModal";
import axios from "axios";
import { toast } from "react-toastify";
import { decryptToken } from "./utils/getToken";
import DOMPurify from "dompurify";



const EquipmentsDetail = () => {

    const { id } = useParams();
    const [equipment, setEquipment] = useState(null);
    const navigate = useNavigate();
    const [website, setWebsite] = useState();
    const url = API_BASE_URL;
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const fetchEquipment = async () => {
            try {
                const res = await fetch(`${url}/grouped-product/single/${id}`);
                const result = await res.json();
                setEquipment(result);
            } catch (error) {
                console.error("Error loading equipment:", error);
                setEquipment(null);
            }
        };

        if (id) fetchEquipment();
    }, [id]);

    const handleEdit = () => {
        navigate("/edit-expense", { state: equipment });
    };

    const slugify = (text) =>
        text?.trim().toLowerCase().replace(/\s+/g, "-").replace(/[^\p{L}\p{N}-]/gu, "");


    const handleDelete = () => {
        if (!equipment?.product_id) return;

        Swal.fire({
            title: 'Are you sure?',
            text: `This will permanently delete "${equipment.title}"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.delete(`${url}/grouped-product/${equipment.product_id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    if (response.status === 200) {
                        toast.success("Product deleted successfully");
                        navigate("/products");
                    }
                } catch (error) {
                    console.error(error);
                    toast.error("Failed to delete product");
                }
            }
        });
    };

    const fetchDataWebsite = async () => {
        try {
            const response = await fetch(`${url}/register/single/${user.main_id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            console.log(res);
            setWebsite(res.users.website_link)
        } catch (error) {
            console.error(error)
        }
    }


    const handleNavigateDescription = () => {
        window.location.href = `${website}/products/${equipment?.category_details?.category}/${slugify(equipment.title)}/${equipment.product_id}`
    }

    const handleNavigateMain = (pro_id, pro_type) => {
        if (pro_type === "Simple Product") {
            navigate(`/simple-productedit/${pro_id}`)
        } else if (pro_type === "Variable Product") {
            navigate(`/variableedit-product/${pro_id}`)
        } else if (pro_type === "Affiliate Product") {
            navigate(`/affiliate-productedit/${pro_id}`)
        } else if (pro_type === "Grouped Product") {
            navigate(`/grouped-productedit/${pro_id}`)
        }
    }

    useEffect(() => {
        fetchDataWebsite();
    }, [])

    if (!equipment) return <p>Loading equipment details...</p>;

    return (
        <>
            <div className="ecom-customer-detail-container">

                {/* Header */}
                <div className="ecom-customer-header-detail">
                    <div className="ecom-customer-header-left-container">
                        <ArrowLeftIcon onClick={() => navigate("/products")} />
                        <h2 className="ecom-customer-name-highlight">
                            Product Detail
                        </h2>
                    </div>
                    <div className="ecom-customer-header-right-container">
                        <EyeIcon onClick={handleNavigateDescription} className="cursor-pointer"/>
                        <PenIcon onClick={() => handleNavigateMain(equipment.product_id, equipment.product_type)} />
                        <Trash2Icon onClick={handleDelete} />
                    </div>
                </div>

                {/* SECTION 1: Basic Info */}
                <section className="ecom-customer-section-box ecom-customer-details">
                    <h4><InfoIcon size={16} style={{ marginRight: 8 }} /> Basic Info</h4>
                    <div className="ecom-customer-detail-grid">
                        <div><label>Product name:</label> <span> {equipment.title || "Product Name"}</span></div>
                        <div><label>Product ID:</label> <span>{equipment.product_id || "—"}</span></div>
                        <div><label>Type:</label> <span>{equipment.product_type || "—"}</span></div>
                        <div><label>Status:</label> <span>{equipment.status || "—"}</span></div>
                        <div><label>Stock:</label> <span>{equipment.stock || "—"}</span></div>
                    </div>
                </section>

                {/* SECTION 2: Images */}
                <section className="ecom-customer-section-box ecom-customer-details">
                    <h4><ImageIcon size={16} style={{ marginRight: 8 }} /> Images</h4>
                    <div>
                        <label>Product Image:</label><br /><br />
                        <img
                            src={`${url}${equipment.image}`}
                            alt={equipment.title}
                            style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: 10, border: "1px solid #333" }}
                        />
                    </div>
                    <br />
                    <div>
                        <label>Product Galleries</label><br /><br />
                        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                            {JSON.parse(equipment.gallery || "[]").map((img, i) => (
                                <img
                                    key={i}
                                    src={`${url}${img.url}`}
                                    alt={`gallery-${i}`}
                                    width="60"
                                    height="60"
                                    style={{ objectFit: "cover", borderRadius: 8, border: "1px solid #333" }}

                                />
                            ))}
                        </div>
                    </div>
                </section>

                {/* SECTION 3: Descriptions */}
                <section className="ecom-customer-section-box ecom-customer-details">
                    <h4><FileText size={16} style={{ marginRight: 8 }} /> Descriptions</h4>
                    <div className="ecom-customer-detail-grid">
                        <div>
                            <label>Long Description</label>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(equipment.description || "<p>—</p>", {
                                        USE_PROFILES: { html: true },
                                    }),
                                }}
                            />
                        </div>
                        <div>
                            <label>Short Description</label>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                        equipment.short_description || "<p>—</p>",
                                        { USE_PROFILES: { html: true } }
                                    ),
                                }}
                            />
                        </div>
                    </div>
                </section>

                {/* SECTION 4: Pricing */}
                <section className="ecom-customer-section-box ecom-customer-details">
                    <h4>
                        <BadgePercentIcon size={16} style={{ marginRight: 8 }} /> Pricing
                    </h4>
                    {(() => {
                        let variations = [];
                        try {
                            variations = JSON.parse(equipment.variation || "[]");
                        } catch { }

                        const salePrices = variations.map(v => parseFloat(v.salePrice)).filter(p => p > 0);
                        const originalPrices = variations.map(v => parseFloat(v.price)).filter(p => p > 0);

                        const minSale = Math.min(...salePrices);
                        const maxSale = Math.max(...salePrices);
                        const minOriginal = Math.min(...originalPrices);
                        const maxOriginal = Math.max(...originalPrices);

                        return (
                            <div className="ecom-customer-detail-grid">
                                {salePrices.length > 0 && (
                                    <div>
                                        <label>Sale Price:</label>
                                        <span>
                                            ₹ {minSale === maxSale ? minSale : `${minSale} - ${maxSale}`}
                                        </span>
                                    </div>
                                )}

                                {originalPrices.length > 0 && (
                                    <div>
                                        <label>Original Price:</label>
                                        <span>
                                            ₹ {minOriginal === maxOriginal ? minOriginal : `${minOriginal} - ${maxOriginal}`}
                                        </span>
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                </section>


                {/* SECTION 5: Category & Meta */}
                <section className="ecom-customer-section-box ecom-customer-details">
                    <h4><TagsIcon size={16} style={{ marginRight: 8 }} /> Category & Meta</h4>
                    <div className="ecom-customer-detail-grid">
                        <div><label>Category:</label> <span>{equipment.category || "—"}</span></div>
                        <div><label>Type:</label> <span>{equipment.categorytype || "—"}</span></div>
                        <div><label>Delivery Days:</label> <span>{equipment.delivery_days || "—"}</span></div>
                        <div><label>Created By:</label> <span>{equipment.user_name || "—"}</span></div>
                    </div>
                </section>

                {/* SECTION 6: Attributes */}
                <section className="ecom-customer-section-box ecom-customer-details">
                    <h4><SlidersHorizontalIcon size={16} style={{ marginRight: 8 }} /> Attributes</h4>
                    {(() => {
                        let attributes = [];
                        try {
                            attributes = JSON.parse(equipment.attribute || "[]");
                        } catch { }

                        return attributes.map(attr => (
                            <div className="ecom-customer-detail-grid">
                                <div key={attr.id}>
                                    <label>{attr.name}:</label>
                                    <span>{attr.selectedTerms?.map(term => term.name).join(", ") || "—"}</span>
                                </div>
                            </div>
                        ));
                    })()}
                </section>

                {/* SECTION 7: Key Features */}
                <section className="ecom-customer-section-box ecom-customer-details">
                    <h4><StarIcon size={16} style={{ marginRight: 8 }} /> Key Features</h4>
                    {(() => {
                        let features = [];
                        try {
                            features = JSON.parse(equipment.key_features || "[]");
                        } catch { }
                        return features.length > 0 ? (
                            <ol>{features.map((f, i) => <li key={i}>{f}</li>)}</ol>
                        ) : (
                            <p>—</p>
                        );
                    })()}
                </section>
            </div >
            <EquipmentsModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default EquipmentsDetail;
